export default __webpack_public_path__ + "static/media/cuciVoucher3.a735fe3a.png";